import { 
   
    FaWhatsapp,
    FaYoutube,
    
    FaInstagram,
    FaFacebook,
    
    FaTiktok,FaMapMarkerAlt, FaPhone, FaEnvelope} from 'react-icons/fa'; // Import the left arrow icon
    import { useLanguage } from '../context/LanguageContext.js';
    import {FaXTwitter} from 'react-icons/fa6'
export default function Footer(){
  const { t, language} = useLanguage();
    return <div className="footer-container">
<div className="footer">
<div className="description-class">
<h1>MP <span>Technology</span></h1>
<p>{t('footer.description')}</p>
<div className="social-icon-footer">
{/* WhatsApp */}
<a
          href="https://wa.me/+966557380850" // Replace with your WhatsApp link
          target="_blank"
          rel="noopener noreferrer"
          
        >
          <FaWhatsapp className='footer-icon' />
        </a>

        {/* YouTube */}
        <a
          href="https://www.youtube.com/@MpTechnology-sa" // Replace with your YouTube link
          target="_blank"
          rel="noopener noreferrer"
         
        >
          <FaYoutube className='footer-icon' />
        </a>

        {/* Twitter */}
        <a
          href="https://x.com/mptech_sa?s=21" // Replace with your Twitter link
          target="_blank"
          rel="noopener noreferrer"
          
        >
          <FaXTwitter className='footer-icon' />
        </a>

        {/* Instagram */}
        <a
          href="https://www.instagram.com/mptechsa" // Replace with your Instagram link
          target="_blank"
          rel="noopener noreferrer"
          
        >
          <FaInstagram className='footer-icon' />
        </a>

        {/* Facebook */}
        <a
          href="https://www.facebook.com/profile.php?id=61573985175328&.." // Replace with your Facebook link
          target="_blank"
          rel="noopener noreferrer"
          
        >
          <FaFacebook className='footer-icon' />
        </a>

        

        {/* TikTok */}
        <a
          href="https://www.tiktok.com/@mp_tech.sa" // Replace with your TikTok link
          target="_blank"
          rel="noopener noreferrer"
          
        >
          <FaTiktok className='footer-icon' />
        </a>
</div>
</div>
<div className='contact-info'>
<h1>{t('footer.contact_title')}</h1>
<div className='contact-icon'>
<h5><FaMapMarkerAlt className='contact-footer-icon'/><span>{t('footer.address')}</span></h5>
<h5><a href='tel:+966557380850'><FaPhone className='contact-footer-icon'/><span>{t('footer.phone')}</span></a></h5>
<h5><a href='mailto:info@mptech.com.sa'><FaEnvelope className='contact-footer-icon'/><span>{t('footer.email')}</span></a></h5>
</div>
</div>
</div>
<p className='all-right-reserved'>{t('footer.all_right')}<span>  &copy; </span> <p className='number-text'>2025</p> </p>
  </div>
}